<div #backdrop class="backdrop" [class.show]="isOpen()">
  <div #modal class="gstar-modal">
    <div class="ap-modal-header">
      <h2 class="ap-modal-title">{{ title() }}</h2>
      <div class="ap-modal-header-icons-container">
        <button
          type="button"
          class="ap-modal-header-icon ap-modal-header-close"
          (click)="cancelHandler(false)">
          <span class="Appkit4-icon icon-close-outline"></span>
        </button>
      </div>
    </div>
    <div>
      <ng-template #dynamicContentHost></ng-template>
    </div>
    <div class="ap-modal-footer">
      <div class="ap-modal-footer-customize">
        @if (!hideCancel()) {
          <ap-button
            btnType="secondary"
            [label]="cancelLabel()"
            (onClick)="cancelHandler(false)"
            (keyup.enter)="cancelHandler()" />
        }

        @if (!hideConfirm()) {
          <ap-button
            btnType="primary"
            [label]="confirmLabel()"
            (onClick)="confirmHandler()"
            [disabled]="disableConfirm()"
            (keyup.enter)="confirmHandler()" />
        }
      </div>
    </div>
  </div>
</div>
